import { createContext } from "react";

export const ModalHeadingIdContext = createContext<string | undefined>(undefined);
